import { z } from 'zod'
import { wecomDeliveryListSchema } from '@super-mega/server/contracts/wecom-push'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'
import { createdAtSearchShape, createdAtSortSearchShape, creatorMemberSearchShape } from '@/utils/list-query.ts'

export const botDeliveriesSearchSchema = wecomDeliveryListSchema.omit({ botId: true }).extend({
  current: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce.number().int().positive().max(100).catch(20),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  ...creatorMemberSearchShape,
  ...createdAtSearchShape,
  ...createdAtSortSearchShape
})
export const botDeliveriesPersistence = createListQueryPersistence(
  'super-mega:bot-deliveries:list-query',
  botDeliveriesSearchSchema
)
export type BotDeliveriesSearch = z.infer<typeof botDeliveriesSearchSchema>
